import { useLayoutEffect } from 'react';

export const scrollWindowToTop = (): void => {
  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
};

export const useScrollToTopOnChange = (dependency: unknown): void => {
  useLayoutEffect(() => {
    scrollWindowToTop();
  }, [dependency]);
};
